import { useState } from "react";
import CustomCommonTooltip from "@/shared/components/ui/Upload/ToolTip/CustomCommonTooltip";

const MetricCard = ({ label, value, onView }) => {
  const count = Number(value) || 0;

  return (
    <div className="flex items-center justify-between gap-2 rounded-lg border border-gray-100 bg-gray-50/70 px-2.5 py-2 dark:border-gray-800 dark:bg-gray-800/40">
      <span className="min-w-0 truncate text-[11px] font-medium text-gray-600 dark:text-gray-300">
        {label}
      </span>
      <div className="flex shrink-0 items-center gap-2">
        <strong className="text-sm font-semibold text-gray-900 dark:text-gray-100">
          {count}
        </strong>
        {count > 0 && onView && (
          <button
            type="button"
            className="text-[10px] font-medium text-secondary hover:underline dark:text-secondary-light"
            onClick={onView}
          >
            View
          </button>
        )}
      </div>
    </div>
  );
};

const ChannelAnalyticsCard = ({
  title,
  Icon,
  iconClassName,
  iconBackgroundClassName,
  metrics,
  primaryMetric,
  onView,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const primaryCount = Number(primaryMetric?.value) || 0;

  return (
    <div
      className="min-w-0 rounded-xl border border-gray-200 bg-white p-3 shadow-sm transition-all duration-300 hover:bg-gray-50/50 dark:border-gray-800 dark:bg-gray-900 dark:hover:bg-gray-800/50"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="mb-3 flex items-center gap-2 border-b border-gray-100 pb-2 dark:border-gray-800">
        <div
          className={`flex items-center justify-center rounded-md p-1.5 ${iconBackgroundClassName}`}
        >
          <Icon className={iconClassName} size={15} strokeWidth={2} />
        </div>
        <h3 className="text-xs font-semibold uppercase tracking-wide text-gray-800 dark:text-gray-100">
          {title}
        </h3>
      </div>

      <div className="flex items-center justify-between gap-2">
        <div className="flex items-baseline gap-2">
          <span className="text-xl font-semibold text-gray-900 dark:text-gray-100">
            {primaryCount}
          </span>
          <span className="text-[11px] font-medium text-gray-500 dark:text-gray-400">
            {primaryMetric?.label}
          </span>
        </div>
        <CustomCommonTooltip
          content={`${primaryMetric?.engagementLabel || "Reply Engagement"}: ${primaryMetric?.percentage ?? "0%"}`}
          placement="top"
        >
          <span className="shrink-0 rounded-lg bg-gray-100 px-2 py-0.5 text-[10px] font-medium text-gray-600 dark:bg-gray-800 dark:text-gray-300">
            {primaryMetric?.percentage ?? "0%"}
          </span>
        </CustomCommonTooltip>
      </div>

      <div
        className={`overflow-hidden transition-all duration-300 ${
          isHovered
            ? "mt-3 max-h-96 translate-y-0 opacity-100"
            : "max-h-0 translate-y-2 opacity-0"
        }`}
      >
        <div className="flex flex-col gap-1.5">
          {metrics.map((metric) => (
            <MetricCard
              key={metric.label}
              label={metric.label}
              value={metric.value}
              onView={
                metric.action && Number(metric.value) > 0
                  ? () => onView?.(metric.action)
                  : undefined
              }
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ChannelAnalyticsCard;
